import React from 'react';
import PropTypes from 'prop-types';

/**
 * EndRow Component
 *
 * This component renders a table row indicating the end of a cycle or session.
 * It receives a 'data' object containing:
 * - 'text': a string to display on the left side of the row.
 * - 'totalDuration': a node (string or React element) representing the total duration,
 *   displayed on the right side of the row.
 *
 * The row spans the full width of the table using 'colSpan' and uses flexbox to align
 * the text and duration at opposite ends of the row.
 *
 * An optional prop `className` can be provided to customize the text styling (e.g., font-size, font-weight).
 *
 * Props:
 * - data: { text: string, totalDuration: node }
 * - className: string (optional CSS classes to append to the default classes)
 */
const EndRow = ({ data, className }) => {
  const { text, totalDuration } = data;

  const defaultClasses = 'px-4 py-1.5 text-black italic pl-[50px]';
  const combinedClasses = `${defaultClasses} ${className ? className : 'text-xs'}`;

  return (
    <tr data-testid="end-row" className="bg-white border-b-2 whitespace-nowrap">
      <td colSpan="100%" className={combinedClasses}>
        <div className="flex justify-between">
          <span className="self-center">{text}</span>
          <span className="mr-6">{totalDuration}</span>
        </div>
      </td>
    </tr>
  );
};

EndRow.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
    totalDuration: PropTypes.node.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

export default EndRow;
